import { confirmable, createConfirmation, ReactConfirmProps } from "react-confirm";
import { DialogTitle, DialogContent, DialogActions, Button, Grid } from "@mui/material";
import { VehicleAssessment } from "system/Domain";
import { notFound } from "system/storage";
import { AssessmentItem } from "Pages/Vehicles/Assessments/AssessmentsPage";
import AssessmentItemCard from "Pages/Vehicles/Assessments/AssessmentItemCard";
import ThemedDialog from "../Components/ThemedDialog";

interface SelectVehicleAssessmentDialogProps extends ReactConfirmProps<string | null> {
	assessments: VehicleAssessment[];
	linkedAssessmentId?: string;
}

const toAssessmentItem = (va: VehicleAssessment, linkedAssessmentId?: string): AssessmentItem => ({
	type: "VehicleAssessment",
	id: va.id,
	date: va.assessmentDate,
	dateCreated: va.dateCompleted,
	dateRejected: va.dateRejected || null,
	externalId: va.externalId,
	assessment: va.attachments.find((a) => a.type === "Gutachten")?.storageFile || notFound,
	isLinked: va.id === linkedAssessmentId,
});

const SelectVehicleAssessmentDialog = ({ show, proceed, assessments, linkedAssessmentId }: SelectVehicleAssessmentDialogProps) => {
	return (
		<ThemedDialog open={show} fullWidth maxWidth="lg">
			<DialogTitle>Gutachten auswählen</DialogTitle>
			<DialogContent>
				<Grid container spacing={2} sx={{ mt: 1 }}>
					{assessments.map((va) => (
						<Grid item key={va.id}>
							<AssessmentItemCard
								assessmentItem={toAssessmentItem(va, linkedAssessmentId)}
								onSelect={() => proceed(va.id)}
								selectText="Auswählen"
							/>
						</Grid>
					))}
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button color="secondary" onClick={() => proceed(null)}>
					Abbrechen
				</Button>
			</DialogActions>
		</ThemedDialog>
	);
};

export default (assessments: VehicleAssessment[], linkedAssessmentId?: string) => {
	const dialog = confirmable(
		(props: ReactConfirmProps<string | null>) => (
			<SelectVehicleAssessmentDialog {...props} assessments={assessments} linkedAssessmentId={linkedAssessmentId} />
		)
	);
	return createConfirmation<string | null>(dialog)();
};
